/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesStoreBank131PayWithSbpResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreBank131PayWithSbpResponse(value) {
    if (!('SbpLink' in value) || value['SbpLink'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreBank131PayWithSbpResponseFromJSON(json) {
    return FxIdWebFeaturesStoreBank131PayWithSbpResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PayWithSbpResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SbpLink': json['SbpLink'],
    };
}
export function FxIdWebFeaturesStoreBank131PayWithSbpResponseToJSON(json) {
    return FxIdWebFeaturesStoreBank131PayWithSbpResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreBank131PayWithSbpResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SbpLink': value['SbpLink'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreBank131PayWithSbpResponse.js.map